import { forwardRef } from "react";
import { Checkbox } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomCheckBox = forwardRef(({ size, ...props }, ref) => {
  const isDesktop = useIsDesktop();
  const responsiveSize = size ?? (isDesktop ? "sm" : "xs");
  return <Checkbox ref={ref} size={responsiveSize} {...props} />;
});

export default CustomCheckBox;
